function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M359.79,254h5.43v0.54a0.37,0.37,0,0,0,.37.37h1.22a0.37,0.37,0,0,0,.37-0.37v-0.67a1.83,1.83,0,0,0-1.83-1.83h-5.68a1.83,1.83,0,0,0-1.83,1.83v0.67a0.37,0.37,0,0,0,.37.37h1.22a0.37,0.37,0,0,0,.37-0.37V254Zm0,0",
  transform: "translate(-349.87 -252)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M371.7,262.64H353.3a0.86,0.86,0,0,0-.86.93l1.54,19a2,2,0,0,0,2,1.88h13a2,2,0,0,0,2-1.88l1.54-19a0.86,0.86,0,0,0-.86-0.93h0Zm-13.94,19.8h-0.06a1,1,0,0,1-1-.92l-1-15.61a1,1,0,0,1,2-.12l1,15.61a1,1,0,0,1-.92,1h0Zm5.73-1a1,1,0,0,1-2,0V265.85a1,1,0,1,1,2,0v15.61Zm5.75-15.55-0.92,15.61a1,1,0,0,1-1,.92h-0.06a1,1,0,0,1-.92-1l0.92-15.61a1,1,0,1,1,2,.12h0Zm0,0",
  transform: "translate(-349.87 -252)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M375.08,259.61l-0.64-1.93a1.25,1.25,0,0,0-1.18-.85H351.74a1.25,1.25,0,0,0-1.18.85l-0.64,1.93a0.81,0.81,0,0,0,.77,1.06h23.64a0.8,0.8,0,0,0,.43-0.12,0.81,0.81,0,0,0,.34-0.94h0Zm0,0",
  transform: "translate(-349.87 -252)"
});

var SvgTrashIcon = function SvgTrashIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 25.25 32.46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trash_icon.4be8be29.svg";
export { ForwardRef as ReactComponent };